import { NoteType } from './types';

export const defaultNoteData = {
  text: '',
  startDate: null,
  endDate: null,
  urgent: false,
  noteType: NoteType.OneDay,
};
